import type { ProductTaxonomyRenameDefinition } from '../types';

export const messageActivityRename = {
  copy: {
    'nav.review.outbox': {
      current: 'Deliveries & Drafts',
      future: 'Message activity',
    },
    'nav.review.outbox.deliveries': {
      current: 'Deliveries',
      future: 'Sent',
    },
    'nav.review.outbox.drafts': {
      current: 'Drafts',
      future: 'Outbox',
    },
  },
  routes: {
    'messageActivity.index': {
      current: '/workspaces/:workspaceId/journeys/outbox',
      future: '/workspaces/:workspaceId/journeys/message_activity/sent',
    },
    'messageActivity.sent': {
      current: '/workspaces/:workspaceId/journeys/outbox/deliveries',
      future: '/workspaces/:workspaceId/journeys/message_activity/sent',
    },
    'messageActivity.outbox': {
      current: '/workspaces/:workspaceId/journeys/outbox/drafts',
      future: '/workspaces/:workspaceId/journeys/message_activity/outbox',
    },
  },
  sideNavItemIds: {
    outbox: 'message-activity',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
